import React from 'react';
import { motion } from 'framer-motion';
import { UserPlusIcon, CheckCircle2Icon, Loader2Icon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { useAssociateStatus } from './AssociateStatusContext';
export function AssociateButton({
  idleLabel
}: {
  idleLabel: string;
}) {
  const {
    t
  } = useLanguage();
  const {
    status,
    request
  } = useAssociateStatus();
  if (status === 'idle') {
    return <motion.button whileTap={{
      scale: 0.97
    }} onClick={request} className="relative overflow-hidden w-full flex items-center justify-center gap-2 rounded-2xl py-[22px] pl-6 pr-20 font-semibold text-base bg-white text-blue-600 border-2 border-blue-100 hover:border-blue-200 hover:bg-slate-50 min-h-[77px] transition-colors" data-id="element-14">
        <UserPlusIcon size={20} className="text-blue-600" data-id="element-15" />
        {idleLabel}
        <img src="https://cdn.magicpatterns.com/uploads/eAWfw77qezj27KdafqpQRB/ChatGPT_Image_Jun_3,_2026,_10_49_00_PM.png" alt="Mike, store associate" className="absolute right-2 bottom-0 h-[68px] w-16 object-cover object-top pointer-events-none" data-id="element-16" />
      </motion.button>;
  }
  if (status === 'requesting') {
    return <motion.div animate={{
      boxShadow: ['0 0 0 0 rgba(250, 204, 21, 0.7)', '0 0 0 14px rgba(250, 204, 21, 0)']
    }} transition={{
      repeat: Infinity,
      duration: 1.4,
      ease: 'easeOut'
    }} className="w-full flex items-center justify-center gap-2 rounded-2xl py-[22px] px-6 font-semibold text-base bg-yellow-400 text-yellow-950 border-2 border-yellow-500 min-h-[77px]" data-id="element-17">
        <motion.span animate={{
        rotate: 360
      }} transition={{
        repeat: Infinity,
        duration: 1,
        ease: 'linear'
      }} className="inline-flex" data-id="element-18">
          <Loader2Icon size={20} data-id="element-19" />
        </motion.span>
        {t('associate.requesting')}
      </motion.div>;
  }
  // confirmed
  return <motion.div initial={{
    scale: 0.98,
    opacity: 0.6
  }} animate={{
    scale: 1,
    opacity: 1,
    boxShadow: ['0 0 0 0 rgba(34, 197, 94, 0.7)', '0 0 0 14px rgba(34, 197, 94, 0)']
  }} transition={{
    boxShadow: {
      repeat: Infinity,
      duration: 1.6,
      ease: 'easeOut'
    },
    scale: {
      duration: 0.25
    },
    opacity: {
      duration: 0.25
    }
  }} className="w-full flex items-center justify-center gap-2 rounded-2xl py-[22px] px-6 font-semibold text-base bg-green-500 text-white border-2 border-green-600 min-h-[77px]" data-id="element-20">
      <CheckCircle2Icon size={20} data-id="element-21" />
      {t('associate.onTheWay')}
    </motion.div>;
}